import { ActionTree, ActionContext } from 'vuex';
import ApiService from '@/core/services/ApiService';

// eslint-disable-next-line import/no-cycle
import { RootState } from '@/store';

import { State } from './state';
import { Mutations } from './mutations';
import { ManufacturersMutationTypes } from '@/core/enums/Manufacturers/Mutations';
import { ManufaturersActionTypes } from '@/core/enums/Manufacturers/Actions';
import { TrimLevelsMutationTypes } from '@/core/enums/TrimLevels/Mutations';


import { LinkTypes } from '@/core/enums/Links';
import axios from 'axios';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ManufaturersActionTypes.GET_MANUFACTURERS](
    { commit }: AugmentedActionContext,
    payload: number
  ): any;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [ManufaturersActionTypes.GET_MANUFACTURERS]({ commit },payload) {
    const data = await axios.post(LinkTypes.GET_MANUFACTURERS,payload);
    try {
      commit(ManufacturersMutationTypes.SET_MANUFACTURERS, data.data.data.manufacturers);
    }
    catch(err) {
      console.log(err)
    }
  },

  async [ManufaturersActionTypes.GET_ENGINE_CAPCITY]({ commit },payload) {
    const data = await axios.post(LinkTypes.GET_ENGINE_CAPCITY,payload);
    try {
      commit(TrimLevelsMutationTypes.SET_TRIM_LEVELS, data.data.data.trim_level);
    }
    catch(err) {
      console.log(err)
    }
  },
};

